import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@4.6.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.6__@babel+plugin-syntax-typ_e6bda1d3d4db3783b2df8752bd060da2/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}